'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishEmailCapturePromptMessage = exports.default = undefined;

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _SenderIds = require('conversations-schema/constants/SenderIds');

var _EmailCapturePromptMetadata = require('conversations-schema/records/PubNubMessageMetadata/EmailCapturePromptMetadata');

var _EmailCapturePromptMetadata2 = _interopRequireDefault(_EmailCapturePromptMetadata);

var _getHasVisitorEmail = require('../../selectors/widgetDataSelectors/getHasVisitorEmail');

var _chooseEmailCapturePromptText = require('../selectors/chooseEmailCapturePromptText');

var _getShouldShowOfficeHoursEmailCaptureMessage = require('../../email-capture/selectors/getShouldShowOfficeHoursEmailCaptureMessage');

var _getShouldShowOfficeHoursEmailCaptureMessage2 = _interopRequireDefault(_getShouldShowOfficeHoursEmailCaptureMessage);

var _widgetIsInAwayMode = require('../../availability/selectors/widgetIsInAwayMode');

var _getThreadByThreadId = require('../../threads/selectors/getThreadByThreadId');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

var _canSendNewEmailCapturePromptMessage = require('../../thread-histories/operators/canSendNewEmailCapturePromptMessage');

var _publishMessageToConversation = require('../../actions/PublishActions/publishMessageToConversation');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publishEmailCapturePromptMessage = function publishEmailCapturePromptMessage(_ref) {
  var channel = _ref.channel,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    var thread = (0, _getThreadByThreadId.getThreadByThreadId)(getState(), { threadId: threadId });
    var threadHistory = (0, _historyDataForThread.historyDataForThread)(getState(), { thread: thread });

    if (!(0, _canSendNewEmailCapturePromptMessage.canSendNewEmailCapturePromptMessage)(threadHistory) || (0, _getHasVisitorEmail.getHasVisitorEmail)(getState())) {
      return;
    }

    var shouldShowOfficeHoursEmailCaptureMessage = (0, _getShouldShowOfficeHoursEmailCaptureMessage2.default)(getState());

    var message = (0, _buildUnpublishedMessage.buildUnpublishedMessage)({
      descriptor: {},
      metadata: new _EmailCapturePromptMetadata2.default({
        text: (0, _chooseEmailCapturePromptText.chooseEmailCapturePromptText)(getState()),
        sentOutsideOfficeHours: shouldShowOfficeHoursEmailCaptureMessage,
        sentInAwayMode: (0, _widgetIsInAwayMode.widgetIsInAwayMode)(getState())
      }),
      senderId: _SenderIds.SYSTEM_ID,
      senderType: _senderTypes.SYSTEM,
      threadId: threadId
    });

    dispatch((0, _publishMessageToConversation.publishMessageToConversation)({ channel: channel, message: message, threadId: threadId }));

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'view email capture'
    }));
  };
};

exports.default = publishEmailCapturePromptMessage;
exports.publishEmailCapturePromptMessage = publishEmailCapturePromptMessage;